import { useEffect, useState } from "react";
import { api } from "./api";

// Module-level cache so multiple mounts share one network call and
// tab navigations don't refetch. Small, non-critical marketing data —
// stale for a session is perfectly fine.
let _cache = null;
let _promise = null;

const fetchStats = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = api
    .get("/public/stats")
    .then((r) => {
      _cache = r.data || {};
      return _cache;
    })
    .catch(() => {
      _cache = {};
      return _cache;
    })
    .finally(() => {
      _promise = null;
    });
  return _promise;
};

export const usePublicStats = () => {
  const [stats, setStats] = useState(_cache || {});
  useEffect(() => {
    if (_cache) return;
    let cancelled = false;
    fetchStats().then((s) => {
      if (!cancelled) setStats(s);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return stats;
};
